import { z } from 'zod';
// Request status enum
export const RequestStatusSchema = z.enum(['pending', 'contacted', 'scheduled', 'cancelled', 'rejected']);
// Customer data schema for request form
export const RequestCustomerDataSchema = z.object({
    firstName: z.string().min(1, 'First name is required'),
    lastName: z.string().optional(),
    email: z.string().email('Please enter a valid email address').optional().or(z.literal('')),
    phone: z.string().optional(),
    contactPermission: z.boolean().optional().default(false),
    isFirstVisit: z.boolean().optional(),
}).refine((data) => data.email || data.phone, {
    message: 'Either email or phone is required',
    path: ['phone'],
});
// Request details schema
export const RequestDetailsSchema = z.object({
    preferredDate: z.string().optional(), // ISO date string
    address: z.string().optional(),
    services: z.array(z.string()).optional(),
    description: z.string().optional(),
});
// Create request schema for API
export const CreateRequestSchema = z.object({
    tenantId: z.string().uuid(),
    customerData: RequestCustomerDataSchema,
    requestDetails: RequestDetailsSchema,
    send_owner_notification: z.boolean().optional().default(true),
    send_customer_confirmation: z.boolean().optional().default(true),
});
// Request entity schema (from database)
export const RequestSchema = z.object({
    id: z.string().uuid(),
    tenant_id: z.string().uuid(),
    customer_id: z.string().uuid(),
    preferred_date: z.string().optional().nullable(),
    address: z.string().optional().nullable(),
    services: z.array(z.string()).optional().nullable(),
    description: z.string().optional().nullable(),
    status: RequestStatusSchema,
    created_at: z.string(),
    updated_at: z.string(),
    notes: z.string().optional().nullable(),
});
